import { Instrument, Portfolio, VariableOrderEntity } from "../../domain/entities/OrdersEntity";
import { enrichOrder } from "../../infrastructure/VariableOrderMapper";
import {
    useGetVariableOrders,
    useGetPortfolios,
    useGetShares,
} from "./useOrdersQueries";

import { useMemo } from "react";

type OptionItem = { id: number | string; name: string; detail?: string };

const mapToOptions = (data: OptionItem[] = []) => {
    return data.map(({ id, name, detail }) => ({
        detail,
        label: name,
        value: id.toString(),
    }));
}

export const useVariableOrdersData = () => {
    const { data: ordersData, isLoading: ordersIsLoading, refetch: ordersRefetch } = useGetVariableOrders();
    const { data: portfoliosData, isLoading: portfoliosIsLoading } = useGetPortfolios();
    const { data: instrumentsData, isLoading: instrumentsIsLoading } = useGetShares();

    const portfolios = portfoliosData?.data || [];
    const portfolioOptions = useMemo(() => mapToOptions(portfoliosData?.data), [portfoliosData]);
    const instruments = instrumentsData?.data || [];
    const instrumentOptions = useMemo(() => mapToOptions(
        instruments.map(instrument => ({
            id: instrument.id,
            name: instrument.mnemonic,
            detail: `(${instrument.isin} - ${instrument.issuerName})`
        }))), [instrumentsData]);

    const orders: VariableOrderEntity[] = [];
    if (ordersData?.data) {
        ordersData.data.map((item) => {
            const {
                id,
                status,
                portfolio,
                instrument,
                orderType,
                quantity,
                value,
                createdAt,
                updatedAt,
                confirmNumber,
                limitPrice,
                limitType
            } = item;


            const enrichedItem = enrichOrder(
                {
                    status,
                    portfolio,
                    instrument,
                    orderType,
                    quantity,
                    value,
                    confirmNumber,
                    limitPrice,
                    limitType
                },
                id,
                new Date(createdAt),
                updatedAt ? new Date(updatedAt) : null,
                {
                    portfolios: portfoliosData?.data as unknown as Portfolio[],
                    instruments: instrumentsData?.data as unknown as Instrument[]
                }
            );

            if (enrichedItem) {
                orders.push(enrichedItem);
            }
        });
    }

    const isLoading =
        ordersIsLoading
        || portfoliosIsLoading
        || instrumentsIsLoading

    return {
        orders,
        portfolios,
        portfolioOptions,
        instruments,
        instrumentOptions,
        isLoading,
        ordersRefetch,
    };
}
